import React from "react";

import logo from "../../img/logo/logo_big.png";

class Welcome extends React.Component {
  render() {
    return (
      <div>
        <header id="home">
          <div className="dark-overlay">
            <div className="home-inner ">
              <div className="container-fluid ">
                <div className="row d-flex align-items-center glass">
                  <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 ">
                    <h3>Welcome to</h3>
                    <h1>
                      Find your Future - Insights and tools to support your
                      career thinking
                    </h1>
                    <h3></h3>
                  </div>
                  <div className="col-lg-1 "></div>
                  <div className="col-lg-1 "></div>
                  <div className="col-lg-4 d-none d-lg-block justify-content-center ">
                    <a href="/">
                      <img
                        src={logo}
                        className="img-fluid"
                        alt="Responsive image"
                      />
                    </a>
                  </div>
                </div>

                <div className="divider"></div>
              </div>
              <div className="container">
                <div className="card bg-light text-justify card-border">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="d-flex align-items-center">
                          <div className="p-4 allign-self-start">
                            <i className="fas fa-road fa-2x"></i>
                          </div>
                          <div className="p-4 allign-self-end">
                            <strong>
                              Whatever pathway you choose, the focus of the
                              course is to help you understand yourself, learn
                              how to generate and clarify your career thinking
                              and to help you to understand the UK recruitment
                              timelines. Each pathway contains useful
                              information, practical activities, and reflective
                              questions.
                            </strong>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-lg-12">
                        <div className="d-flex align-items-center">
                          <div className="p-4 allign-self-start">
                            <i className="fas fa-redo-alt fa-2x"></i>
                          </div>
                          <div className="p-4 allign-self-end">
                            <strong>
                              You can always come back and have a go at the
                              other pathways. In fact we encourage you to do so.
                            </strong>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="d-flex align-items-center">
                          <div className="p-4 allign-self-start">
                            <i className="fas fa-clock fa-2x"></i>
                          </div>
                          <div className="p-4 allign-self-end">
                            <strong>
                              This course is really easy to use, there is no
                              time limit meaning you can explore the different
                              pathways at your own pace. Each pathway can take
                              between 15-25 minutes to complete depending on
                              your pace of work.
                            </strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br />
            </div>
          </div>
        </header>

        <div className="container-fluid bg-dark footer">
          <footer className="container">
            <div className="text-center"></div>
            <br />
            <p className="float-right"></p>
          </footer>
        </div>
        <br />
        <br />
      </div>
    );
  }
}

export default Welcome;
